class Dialog extends HTMLElement {
	#elements;

	/**
	 * Set up dialog custom element
	 */
	constructor() {
		super();

		this.#elements = {
			dialog: /** @type {HTMLDialogElement} */ (this.querySelector("dialog")),
			triggers: /** @type {NodeListOf<HTMLButtonElement>} */ (
				document.querySelectorAll(`[popovertarget='${this.id}-dialog']`)
			),
		};

		const isModalDialog = this.#elements.dialog.getAttribute("data-modal");
		if (!isModalDialog) {
			return;
		}

		this.#addEventListeners();
	}

	/**
	 * Add event listeners
	 */
	#addEventListeners() {
		this.#elements.triggers.forEach((button) => {
			button.addEventListener("click", this.#onTriggerClick.bind(this));
		});
	}

	/**
	 * Handle trigger click event
	 * @param {PointerEvent} event
	 */
	#onTriggerClick(event) {
		event.preventDefault();
		if (this.#elements.dialog.open) {
			this.#elements.dialog.close();
		} else {
			this.#elements.dialog.showModal();
		}
	}
}

customElements.define("cd-dialog", Dialog);
